  <iconify-icon
    class="icon-text"
    [icon]="iconSafe"
    [style.fontSize.px]="opsz"
    [attr.data-wght]="wght"
    >
  </iconify-icon>
